export const animations = {
    transitionDelay0: 0,
    transitionDelay250: 250,
};
export const animationTokens = {
    'transition-dialog-in': `visibility ${animations.transitionDelay0}s linear ${animations.transitionDelay0}s, opacity ${animations.transitionDelay250}ms ${animations.transitionDelay0}s, transform ${animations.transitionDelay250}ms`,
    'transition-dialog-out': `visibility ${animations.transitionDelay0}s linear ${animations.transitionDelay250}ms, opacity ${animations.transitionDelay250}ms ${animations.transitionDelay0}s, transform ${animations.transitionDelay250}ms`,
};
